// frontend/src/lib/graphemes.ts
// R5-1: cutting user text by UTF-16 unit (`text.slice(0, 40)`) can split an emoji in half. The
// orphaned half renders as "�" and, sent to the server, cannot be stored (the API refuses it with
// a 422). Every cut of user text — names, post copy, labels — goes through here instead.

const segmenter: Intl.Segmenter | null =
  typeof Intl !== "undefined" && typeof Intl.Segmenter === "function"
    ? new Intl.Segmenter(undefined, { granularity: "grapheme" })
    : null;

/** The characters a reader sees (a flag, a skin-toned or family emoji is ONE), so a cut between two
 *  of them never breaks an emoji. Without Intl.Segmenter: code points — never a lone surrogate. */
export function graphemes(text: string): string[] {
  if (segmenter) return Array.from(segmenter.segment(text), (s) => s.segment);
  return Array.from(text);
}

/** The first `n` characters (graphemes) of `text`. */
export function takeGraphemes(text: string, n: number): string {
  return graphemes(text).slice(0, Math.max(0, n)).join("");
}

/** `text` when it has at most `max` characters, else cut so the result INCLUDING its "…" is `max`
 *  characters long. */
export function truncateText(text: string, max: number): string {
  const g = graphemes(text);
  return g.length <= max ? text : `${g.slice(0, Math.max(0, max - 1)).join("")}…`;
}
